/** Shopify CDN: Minification failed

Line 9:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 10:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 20:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();
      this.shareButton = this.querySelector('.share-button__button');
      this.elements = {
        shareButton: this.querySelector('.share-button__button')
      }

      this.shareButton.addEventListener('click', this.openSocial.bind(this));
    }

    openSocial() {
      this.shareButton.classList.toggle('share-button__button--open');
    }
  });
}
